// extracted by mini-css-extract-plugin
export default {"sessions":"style_sessions__sdH5+","title":"style_title__laOKT"};